import React, { useEffect } from "react";
import { Container, Tab, Tabs } from "react-bootstrap";

import MappingWindow from "./MappingWindow";
import ManagePlan from "../components/subscription/ManagePlan";

import { useDispatch } from "react-redux";

import { useCmsHook } from "../helpers/cmsHook";
import { CmsConstructor } from "../helpers/cmsConstructor";
import CmsEditAndSave from "../helpers/CmsEditAndSave";

const IframeWindow = () => {
  const { setCmsInstance, allowedUsers, isAllowedUser } = useCmsHook();
  const dispatch = useDispatch();

  useEffect(() => {
    if (window.location.pathname === "/iframewindow") {
      const cmsInstance = async () => {
        const cmsObj = await CmsConstructor(dispatch);
        setCmsInstance(cmsObj);
      };
      cmsInstance();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="mapping-window-bg-container py-5">
      {allowedUsers.length > 0 && (
        <div
          className="d-flex flex-row justify-content-center"
          style={{ marginBottom: isAllowedUser && "50px" }}
        >
          <CmsEditAndSave />
        </div>
      )}

      <Container>
        <Tabs
          defaultActiveKey="mapping"
          id="uncontrolled-tab-example"
          className="mb-3"
          transition={false}
        >
          <Tab eventKey="mapping" title="Customise mapping">
            <MappingWindow />
          </Tab>
          <Tab eventKey="managePlan" title="Manage plan">
            <ManagePlan />
          </Tab>
        </Tabs>
      </Container>
    </div>
  );
};

export default IframeWindow;
